import { AppRouteProps } from "@harea/component";
import React from "react";

const CreateContractContainer = React.lazy(() => import("./container/CreateContractContainer"));

export const CreateContractRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "Harea.Contract.List.Title",
        element: <CreateContractContainer />,
        roles: ["DASHBOARD_ADMIN_RH"],
    },
]